import {
  BlueconicAppDownloadModalProps,
  BlueconicCustomUrlModalProps,
  BlueconicDialogues,
  BlueconicLeadCaptureModalProps,
  BlueconicLeadCaptureModalSplitImgProps,
  BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps,
  BlueconicLeadCaptureModalWithNewsletterProps,
  BlueconicLeadCaptureModalWithNewslettersProps,
  BlueconicNewsletterModalProps,
  BlueconicPaywallProps,
  BlueconicPersonalizedReadingHubProps,
  BlueconicRetentionP0Props,
  BlueconicRetentionP1Props,
  BlueconicRetentionP2Props,
  BlueconicRetentionP3Props,
  BlueconicRetentionP4Props,
  BlueconicStickyBannerBottomProps,
} from './propInterfaces';

function isOptionalString(value: unknown): value is string | undefined {
  return typeof value === 'undefined' || typeof value === 'string';
}

function isStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.every((item) => typeof item === 'string');
}

export function isBlueconicCustomUrlModalProps(
  data: BlueconicCustomUrlModalProps
): data is BlueconicCustomUrlModalProps {
  return (
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.disclosure === 'string' &&
    typeof data.customUrl === 'string' &&
    typeof data.buttonText === 'string' &&
    isOptionalString(data.highlight) &&
    data.dialogueType === BlueconicDialogues.CustomUrlModal
  );
}

export function isBlueconicAppDownloadModalProps(
  data: BlueconicAppDownloadModalProps
): data is BlueconicAppDownloadModalProps {
  return data.dialogueType === BlueconicDialogues.AppDownload;
}

export function isBlueconicNewsletterModalProps(
  data: BlueconicNewsletterModalProps
): data is BlueconicNewsletterModalProps {
  return (
    typeof data.newsletterName === 'string' &&
    typeof data.newsletterDescription === 'string' &&
    typeof data.frequency === 'string' &&
    typeof data.newsletterId === 'number' &&
    typeof data.authors === 'string' &&
    isOptionalString(data.redirectUri) &&
    isOptionalString(data.buttonText) &&
    typeof data.leadType === 'string' &&
    isOptionalString(data.highlight) &&
    data.dialogueType === BlueconicDialogues.NewsletterModal
  );
}

export function isBlueconicPaywallProps(
  data: BlueconicPaywallProps
): data is BlueconicPaywallProps {
  return (
    typeof data.title === 'string' &&
    isOptionalString(data.subtitle) &&
    typeof data.offerLink === 'string' &&
    isOptionalString(data.buttonText) &&
    isOptionalString(data.leadType) &&
    data.dialogueType === BlueconicDialogues.Paywall
  );
}

export function isBlueconicStickyBannerBottomProps(
  data: BlueconicStickyBannerBottomProps
): data is BlueconicStickyBannerBottomProps {
  return (
    typeof data.title === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.redirectUri === 'string' &&
    typeof data.loggedInButtonText === 'string' &&
    typeof data.leadType === 'string' &&
    data.dialogueType === BlueconicDialogues.StickyBannerBottom
  );
}
export function isBlueconicLeadCaptureProps(
  data: BlueconicLeadCaptureModalProps
): data is BlueconicLeadCaptureModalProps {
  return (
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    isOptionalString(data.highlight) &&
    isOptionalString(data.disclosure) &&
    typeof data.leadType === 'string' &&
    typeof data.buttonText === 'string'
  );
}

export function isBlueconicSubscribeModalProps(
  data: BlueconicLeadCaptureModalSplitImgProps
): data is BlueconicLeadCaptureModalSplitImgProps {
  return (
    isOptionalString(data.highlight) &&
    typeof data.leadType === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.offerCode === 'string' &&
    typeof data.imgPathLarge === 'string' &&
    typeof data.imgPathMedium === 'string' &&
    typeof data.imgPathSmall === 'string'
  );
}

export function isBlueconicLeadCaptureModalWithNewslettersProps(
  data: BlueconicLeadCaptureModalWithNewslettersProps
): data is BlueconicLeadCaptureModalWithNewslettersProps {
  return (
    Array.isArray(data.newsletterIds) &&
    typeof data.title === 'string' &&
    isOptionalString(data.subtitle) &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.offerCode === 'string'
  );
}

export function isBlueconicLeadCaptureModalWithNewsletterProps(
  data: BlueconicLeadCaptureModalWithNewsletterProps
): data is BlueconicLeadCaptureModalWithNewsletterProps {
  return (
    typeof data.newsletterId === 'number' &&
    isOptionalString(data.subtitle) &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.offerCode === 'string' &&
    isOptionalString(data.newsletterImageUrl)
  );
}

export function isBlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps(
  data: BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps
): data is BlueconicLeadCaptureModalWithMultipleSubscribeOptionsProps {
  return (
    isOptionalString(data.highlight) &&
    typeof data.title === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.buttonText === 'string' &&
    typeof data.leadType === 'string' &&
    typeof data.proOfferCode === 'string' &&
    typeof data.annualOfferCode == 'string'
  );
}

export function isBlueconicPersonalizedReadingHubProps(
  data: BlueconicPersonalizedReadingHubProps
): data is BlueconicPersonalizedReadingHubProps {
  return (
    typeof data.articlesRead === 'string' &&
    Array.isArray(data.favoriteAuthors) &&
    typeof data.minutesRead === 'string' &&
    Array.isArray(data.mostReadNewsletters) &&
    typeof data.mostReadTopic === 'string' &&
    Array.isArray(data.mostReadTopics) &&
    Array.isArray(data.recommendedArticles) &&
    Array.isArray(data.recommendedAuthors) &&
    Array.isArray(data.recommendedNewsletters) &&
    Array.isArray(data.trendingTopics) &&
    typeof data.userId === 'string' &&
    data.dialogueType === BlueconicDialogues.PersonalizedReadingHub
  );
}

export function isBlueconicRetentionP0Props(
  data: BlueconicRetentionP0Props
): data is BlueconicRetentionP0Props {
  return (
    typeof data.buttonText === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.title === 'string' &&
    typeof data.customUrl === 'string' &&
    data.dialogueType === BlueconicDialogues.RetentionP0ContentSmall
  );
}

export function isBlueconicRetentionP1Props(
  data: BlueconicRetentionP1Props
): data is BlueconicRetentionP1Props {
  return (
    isOptionalString(data.highlight) &&
    typeof data.imageURL === 'string' &&
    typeof data.mainCTA === 'string' &&
    typeof data.mainURL === 'string' &&
    isOptionalString(data.optionalCTA) &&
    isOptionalString(data.optionalURL) &&
    typeof data.subtitle === 'string' &&
    typeof data.title === 'string' &&
    data.dialogueType === BlueconicDialogues.RetentionP1SingleContentHighlightText
  );
}

export function isBlueconicRetentionP2Props(
  data: BlueconicRetentionP2Props
): data is BlueconicRetentionP2Props {
  return (
    isOptionalString(data.highlight) &&
    typeof data.imageURL === 'string' &&
    typeof data.mainCTA === 'string' &&
    typeof data.mainURL === 'string' &&
    isOptionalString(data.optionalCTA) &&
    isOptionalString(data.optionalURL) &&
    typeof data.subtitle === 'string' &&
    typeof data.title === 'string' &&
    data.dialogueType === BlueconicDialogues.RetentionP2SingleContentHighlightImage
  );
}

export function isBlueconicRetentionP3Props(
  data: BlueconicRetentionP3Props
): data is BlueconicRetentionP3Props {
  return (
    isStringArray(data.articleSlugs) &&
    isOptionalString(data.articleTitleSection) &&
    typeof data.buttonText === 'string' &&
    typeof data.customUrl === 'string' &&
    isOptionalString(data.highlight) &&
    isOptionalString(data.modalTheme) &&
    typeof data.subtitle === 'string' &&
    typeof data.title === 'string' &&
    data.dialogueType === BlueconicDialogues.RetentionP3MultipleContentText
  );
}

export function isBlueconicRetentionP4Props(
  data: BlueconicRetentionP4Props
): data is BlueconicRetentionP4Props {
  return (
    isStringArray(data.articleSlugs) &&
    typeof data.buttonText === 'string' &&
    typeof data.customUrl === 'string' &&
    typeof data.subtitle === 'string' &&
    typeof data.title === 'string' &&
    data.dialogueType === BlueconicDialogues.RetentionP4MultipleContentImage
  );
}
